import { getApiPathUrl } from 'utils/api';
import * as fetch from 'utils/fetch';

type OutOfOfficeRequest = {
  email: string;
};

const OutOfOfficeService = {
  join: async (data: OutOfOfficeRequest): Promise<void> => {
    const url = getApiPathUrl('/v2/public/ui/newsletters/out-of-office');

    return fetch.post<OutOfOfficeRequest, void>(url, data);
  }
};

export default OutOfOfficeService;
